export const generateIv = () => window.crypto.getRandomValues(new Uint8Array(12));
